// extracted by mini-css-extract-plugin
export default {"contentMessageAlign":"_958b2706ca84b568d370db7e78c436e3"};